export default __webpack_public_path__ + "static/media/refine-icon.6667aeaf.svg";